import { Injectable } from '@angular/core';
import { CategoryCombo, TextFilter, HistoricalComboAthlete, CategorySearchCombo, CountryCombo, YesNotCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { combineLatest } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FiltersofficialsService extends FiltersAbstractService {
  textFilter = new TextFilter('text');
  activeCombo = new HistoricalComboAthlete('Status:', 'currentcombo', undefined,
  [{ item: { Name: 'All', Value: undefined }, position: 0 }, { item: { Name: 'Current', Value: true },
  position: 1 }, {item:{Name:'Historical', Value:false}}]);
  countryCombo = new CountryCombo('Country:', 'country-combo', this.http,  [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true );
  yesNotCombo =new HistoricalComboAthlete('World Archery only:', 'currentcombo', undefined,
  [{ item: { Name: 'Yes', Value: true },
  position: 1 }, {item:{Name:'No', Value:false}}]);

  /**
   * Filters of officials service
   *
   * @memberof FiltersofficialsService
   */
  filtersType = [
    this.textFilter.filterInfo,
    this.countryCombo.filterInfo,
    this.activeCombo.filterInfo,
    this.yesNotCombo.filterInfo
  ]

  constructor(private http: HttpClient) {
    super();
  }

  generateDefaultValues(): void {

  }

  /**
   * Filter data of officials service
   *
   * @returns
   * @memberof FiltersofficialsService
   */
  getDataStreamWithFilters(){
    return combineLatest([
      this.orderSubject,
      this.textFilter.data(),
      this.activeCombo.comboData,
      this.countryCombo.comboData.pipe(filter(a=> a != undefined)),
      this.yesNotCombo.comboData]
      )
  }
}
